<template>
  <v-card outlined class="d-flex outer-container pa-4" width="215px !important">
    <div class="inner-container">
      <v-list-item-avatar
        tile
        size="44"
        class="avatar"
      >
        <v-img :alt="title" :src="icon"></v-img>
      </v-list-item-avatar>
      <h3 class="ma-0">{{ title }}</h3>
      <button-download :file="file" @on-download="handleClickDownload" :disableDownloadIcon="true" />
    </div>
  </v-card>
</template>

<script>
import { SEGMENT_EVENTS } from '../../constants';
import ButtonDownload from '../buttons/button-download-1.vue';

export default {
  props: ['file', 'id', 'title', 'class', 'icon'],
  components: {
    ButtonDownload,
  },
  methods: {
    handleClickDownload() {
      window.analytics.track(SEGMENT_EVENTS.DOWNLOAD_SECTOR_PRIMER, {
        contentTitle: this.title,
        contentId: this.id,
        contentType: 'Sector Primers'
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar {
  margin: unset !important;
  align-self: self-start;
  border-radius: 100% !important;
}
.outer-container {
  overflow: hidden;
  height: 100%;
  &:before {
    content: '';
    width: 4px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: var(--v-primary-base);
  }
  display: flex !important;
  justify-content: center;
  align-items: center;
}
.inner-container {
  display: grid !important;
  height: 100%;
  grid-template-columns: min-content min-content;
  grid-template-rows: 1fr;
  & > *:first-child {
    grid-row: span 2;
  }
  h3 {
    font-size: 15px;
    color: var(--v-secondary-base);
    line-height: 18px;
    font-weight: 500;
  }
  column-gap: 0.8rem;
  row-gap: 0.5rem;
}
</style>
